import { __BEACON_INIT_KEY__ } from "../globals";

export const BEACON_RESET_CSS = {
  ".hsds-beacon .Beacon .BeaconContainer": {
    bottom: "100px !important",
    right: "30px !important",
  },
  ".hsds-beacon .Beacon .BeaconFabButtonFrame": {
    bottom: "30px !important",
    right: "30px !important",
  },
};

export const initBeacon = () => (window as any).Beacon("init", `${__BEACON_INIT_KEY__}`);

export const configureBeacon = () => {
  const config = {
    docsEnabled: true,
    messagingEnabled: true,
    mode: "askFirst",
    messaging: {
      chatEnabled: true,
    },
    enablePreviousMessages: true,
    display: { style: "icon" },
  };
  (window as any).Beacon("config", config);
};

export const destroyBeacon = () => {
  (window as any).Beacon("destroy");
};

export const setIdentity = (self: { name?: string; email?: string; signature?: string }) => {
  (window as any).Beacon("identify", self);
};
